import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type CurrencyViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  codeValue?: { displayId: string; id: string } | null;
  code: string;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
};

export const CurrencyViewForm: React.FC<CurrencyViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    code = "",
    name = "",
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupCurrencyLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine value={code} label={langStore.CurrencyCodeLabel} />
              <ShowMultiLine value={name} label={langStore.CurrencyNameLabel} />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
